import { Label } from "semantic-ui-react"
import Price from "components/Price/Price"
import React from "react"
import OrderModel   from "shop/OrderModel";
import shop from "shop/shop"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0


const ProductPrice = ( { product, className = "pb3 pt1 relative lh-solid" } ) => {

  return <div className={`ProductPrice ${className}`}>
    <div className="flex flex-row pb2">
      {product.pinfos.gc_rabatt && <Label className={"giftcardPercent"} color="red">COUPON {product.pinfos.gc_rabatt} %</Label>}
      {product.isSale && <span className="labelRabatt">&nbsp;&nbsp;{product.pinfos.rabatt}%&nbsp;Rabatt&nbsp;</span>}
      {/*product.isSale && <Label className={"salePercent"} color="red">{product.salePercent}</Label>*/}

    </div>
    
    {product.isSale && <div>
      {/*<div className="unit_multi black-70 f6 pb2 fw2">Stückpreis</div><br/>*/}
      <div className="f4 red b"><Price>{product.price}</Price> <span className="f5 black-60 fw4 pb1 strike "><Price>{product.pinfos.brutto}</Price></span></div>
      <div className=" black-70 f6 fw2 lh-solid">{product.extras.veextrainfo || translate( "Stückpreis" )}</div>
    </div>}
    
    {!product.isSale &&
    <div className="price  lh-solid  ">
      <div className="f3  b"><Price>{product.price}</Price> {product.salePercent &&
      <span className={"black-60 f5 fw4"}>(<Price>{product.originalPrice}</Price> abzgl. {product.salePercent} Rabatt)</span>}
      </div>
      <div className=" black-70 f6 fw2 lh-solid">{product.extras.veextrainfo || translate( "Stückpreis" )}</div>
    </div>}

  </div>
}

export default ProductPrice


// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/ProductPrice.js